export default "__VITE_ASSET__CcSC7APm__"